module.exports = __webpack_public_path__ + "static/media/news-pro-enrolled-program.82eb2f97.png";